export default __webpack_public_path__ + "static/media/Delhi_4.01b5abad.png";